import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class ThanksGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(): boolean {
    const allowed = sessionStorage.getItem('allowThanks');

    if (allowed === 'true') {
      // Limpio el flag para que no puedan volver a entrar sin una nueva acción válida
      sessionStorage.removeItem('allowThanks');
      return true;
    }

    const allowedLocalStorage = localStorage.getItem('ath'); //allowThanks Page: ath -> allow thanks
    if (allowedLocalStorage === 'typ') { // typ -> thanks page
      localStorage.removeItem('ath');
      return true;
    }
    

    // Redirige si se accede manualmente
    this.router.navigate(['/']);
    return false;
  }
}